import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Image, View, Pressable } from 'modules/styled';
import { AVATAR_SIZE } from 'styles/layout';
import { goToProfile } from 'modules/navigation/navigation.actions';
import { resizeImage } from 'utils/img';

UAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.number,
  noLink: PropTypes.bool,
  goToProfile: PropTypes.func,
  sx: PropTypes.object,
};

function UAvatar({ size, user, goToProfile: onPress, noLink, sx }) {
  const dispatch = useDispatch();
  if (!user) return null;
  const profileLink = '/user/profile/' + user.handle;

  const imageSize = size || AVATAR_SIZE;
  const image = user.image
    ? { uri: resizeImage(user.image, imageSize, imageSize) }
    : require('public/img/default_user.jpg');
  const AvatarImage = (
    <Image
      source={image}
      sx={{ height: imageSize, width: imageSize, borderRadius: (imageSize * 8) / 2 }}
    />
  );
  if (noLink) {
    return <View sx={{ ...sx }}>{AvatarImage}</View>;
  }
  return (
    <View sx={{ ...sx }}>
      <Pressable
        nativeAction={() => (onPress ? onPress(user) : dispatch(goToProfile(user)))}
        // onClick={(e) => e.stopPropagation()}
        to={profileLink}
      >
        {AvatarImage}
      </Pressable>
    </View>
  );
}

export default memo(UAvatar);
